<template>
  <section class="cms-body">
    <el-form
      ref="form"
      :model="dataInfo"
      :rules="rules"
      class="cms-form"
      label-width="162px"
    >
      <el-form-item label="类型名称" prop="type_name" class="flex-50">
        <el-input v-model="dataInfo.type_name"></el-input>
      </el-form-item>
      <el-form-item label="类型编号" prop="type_code" class="flex-50">
        <el-input v-model="dataInfo.type_code"></el-input>
      </el-form-item>
      <el-form-item label="服务器" prop="sid" class="flex-50">
        <el-select
          v-model="dataInfo.sid"
          placeholder="请选择"
        >
          <el-option
            v-for="(item, index) in servers"
            :key="item.sid"
            :label="item.server_name+' ['+item.server_code+']'"
            :value="item.sid"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="类型图片" prop="tpid" class="flex-50">
        <cmsPicture
          :picurl="picUrl"
          :showcancel="showCancel"
          @btnClick="openPicDiag()"
          @picCancel="picCancel()"
          @picReset="picCancel()"
        ></cmsPicture>
      </el-form-item> -->
      <!-- <el-form-item label="组态地址" prop="view_url" class="flex-50">
        <el-input
          type="textarea"
          :rows="6"
          v-model="dataInfo.view_url"
        ></el-input>
      </el-form-item> -->
      <el-form-item label="服务价格" prop="type_price" class="flex-50">
        <el-input v-model="dataInfo.type_price">
          <template slot="append">元/年</template>
        </el-input>
      </el-form-item>
      <el-form-item
        label="数据存储间隔"
        prop="storage_interval"
        class="flex-50"
      >
        <el-input v-model="dataInfo.storage_interval">
          <template slot="append">S</template>
        </el-input>
      </el-form-item>
      <el-form-item
        label="数据更新间隔"
        prop="update_interval"
        class="flex-50"
      >
        <el-input v-model="dataInfo.update_interval">
          <template slot="append">S</template>
        </el-input>
      </el-form-item>
      
      <el-form-item label="分派用户" prop="uid" class="flex-50">
        <el-select v-model="dataInfo.uid">
          <template v-for="item in users">
            <el-option
            :key="item.uid"
            :label="item.user_name+'-'+item.role_name"
            :value="item.uid"
          ></el-option>
          </template>
        </el-select>
      </el-form-item>
      <el-form-item label="类型图片" prop="tpid" class="flex-50">
        <cmsPicture
          :picurl="picUrl"
          :showcancel="showCancel"
          @btnClick="openPicDiag()"
          @picCancel="picCancel()"
          @picReset="picCancel()"
        ></cmsPicture>
      </el-form-item>
      <el-form-item label="备注" prop="type_des" class="flex-100">
        <el-input
          type="textarea"
          :rows="6"
          v-model="dataInfo.type_des"
        ></el-input>
      </el-form-item>

      <!-- 按钮组 -->
      <div class="form-footer">
        <el-button type="primary" @click="update()" v-if="isAdmin">修改</el-button>
        <el-button type="info" @click="$router.go(-1)" v-if="isAdmin">放弃修改</el-button>
        <el-button type="info" @click="$router.go(-1)" v-if="!isAdmin">返回</el-button>
        <el-button type="info" @click="reset" v-if="isAdmin">重置</el-button>
        <span class="gray" v-if="isAdmin">
          选择“修改”按钮，提交修改后将跳转到对应的列表页</span
        >
      </div>
    </el-form>

    <!-- 图片选择 -->
    <el-dialog title="图片选择" :visible.sync="picDialog">
      <cmsPictureList
        :total="total"
        :tableData="tableData"
        @picClick="picClick"
        @change="getPages"
      ></cmsPictureList>
    </el-dialog>
  </section>
</template>
<script>
import va from "@/rules";
import service from "@/untils/service";
import formMixns from "@/mixins/form";
import listMixins from "@/mixins/list";

export default {
  mixins: [formMixns, listMixins], //普通表单变量
  data() {
    let required = va.required("此项必填");
    let validateCode = va.validateCode(
      "设备类型编号已存在",
      "DevType/IsExist",
      this.$route.query.id
    );
    let number = va.number("此项必须为数字");
    let double = va.double("此项必须为数字或小数");

    return {
      rules: {
        // 校验规则
        type_code: [required, validateCode],
        type_name: [required],
        sid: [required],
        type_price: [double],
        storage_interval: [number]
      },
      params: {
        pageNo: "1",
        pageSize: "10"
      },
      picDialog: false,
      picUrl: "",
      oldPic: {
        tpid: "", //记录修改前的tpid
        pic_url: "" //记录修改前的pic_url
      },
      showCancel: false,
      showReset: false,
      isAdmin:false,
      servers:[],
      users:[]
    };
  },
  methods: {
    update() {
      this.updateDataInfo("DevType/Update", this.dataInfo, "/dtype/list");
    },
    getDataInfo(id) {
      //重写获取表单数据
      this.$api
        .post("DevType/DetailV", { id: id })
        .then(res => {
          if (res.status === 200) {
            this.loading = false;
            this.dataInfo = res.data.Data;
            this.oldPic = {
              //记录图片信息
              tpid: this.dataInfo.tpid,
              pic_url: this.dataInfo.pic_url
            };
            this.picUrl = this.dataInfo.pic_url;
          }
        })
        .catch(err => {
          this.loading = false;
        });
    },
    reset() {
      this.getDataInfo(this.id);
    },
    openPicDiag() {
      this.picDialog = true;
    },
    picClick(id, url) {
      this.dataInfo.tpid = id;
      this.picUrl = url;
      if (this.dataInfo.tpid !== this.oldPic.tpid) {
        this.showCancel = true;
      } else {
        this.showCancel = false;
      }
      this.showReset = true;
    },
    picCancel() {
      this.dataInfo.tpid = this.oldPic.tpid;
      this.picUrl = this.oldPic.pic_url;
      this.showCancel = false;
      this.showReset = true;
    },
    picReset() {
      this.dataInfo.tpid = null;
      this.picUrl = "";
      this.showCancel = false;
      this.showReset = false;
    },
    loadOptions(){
      this.$api.post('Server')
      .then(res=>{
        if(res.status===200){
          this.servers=res.data.Data;
        }
      })

      this.$api.post('User',{rid:2})
      .then(res=>{
        if(res.status===200){
          this.users=res.data.Data.list;
        }
      })
    }
  },
  created() {
    //初始获取数据
    this.isAdmin = this.$isAdmin();
    this.loadOptions()
    this.loading = true;
    this.id=this.$route.query.id;
    this.getDataInfo(this.$route.query.id);

    //获取图片
    this.params.uid = this.$store.state.userInfo.id;
    this.initTableData("Picture/PagedView", this.params);
  }
};
</script>
